/**
 * ブラウザにアップしたアバター写真を編集するモーダル
 */

import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import { useCallback, useState } from 'react';
import Cropper, { Area } from 'react-easy-crop';

type Props = {
  imageUrl: string;
  onClose: () => void;
  onSave: (croppedAreaPixels: Area) => void;
};

const AvatarEditModal = ({ imageUrl, onClose, onSave }: Props) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const onCropComplete = useCallback((_croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = () => {
    if (croppedAreaPixels) {
      onSave(croppedAreaPixels);
    }
  };

  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10 md:gap-4 md:px-4 md:py-6'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>アップロードした画像を編集</h2>
        </div>

        <div className='flex flex-col gap-2 md:gap-0'>
          <div className='relative h-[300px]'>
            <Cropper
              image={imageUrl}
              crop={crop}
              zoom={zoom}
              aspect={1}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              cropShape='round'
              showGrid={false}
              style={{
                containerStyle: {
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#fff',
                },
              }}
            />
          </div>
          <div className='mt-4'>
            <input
              type='range'
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby='Zoom'
              onChange={(e) => setZoom(Number(e.target.value))}
              className='w-full'
            />
          </div>
        </div>

        <div className='mt-auto flex w-full justify-center gap-5 md:gap-2'>
          <div className='w-full max-w-[160px]'>
            <Button
              size='s'
              outline
              fullWidth
              fullRounded
              onClick={onClose}
            >
              キャンセル
            </Button>
          </div>
          <div className='w-full max-w-[160px]'>
            <Button
              size='s'
              fullWidth
              fullRounded
              onClick={handleSave}
            >
              保存する
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AvatarEditModal;
